import { z } from 'zod';

export const frontendEnvSchema = z
  .object({
    VITE_API_URL: z.union([z.literal(''), z.string().url()]),
    VITE_BUILD_UPDATED_AT: z.string().datetime(),
    PROD: z.boolean(),
    DEV: z.boolean(),
  })
  .strict();

const frontendEnv = frontendEnvSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_BUILD_UPDATED_AT: import.meta.env.VITE_BUILD_UPDATED_AT,
  PROD: import.meta.env.PROD,
  DEV: import.meta.env.DEV,
});

export const frontendConfig = {
  env: frontendEnv,
  apiUrl: frontendEnv.VITE_API_URL,
  buildUpdatedAt: frontendEnv.VITE_BUILD_UPDATED_AT,
  isProduction: frontendEnv.PROD,
  isDevelopment: frontendEnv.DEV,
} as const;
